
import { useState } from 'react';
import Header from './components/Header';
import FilterPanel from './components/FilterPanel';
import MapDashboard from './components/MapDashboard';
import DetailedAnalysis from './components/DetailedAnalysis';
import RegionComparison from './components/RegionComparison';

export default function Dashboard() {
  const [selectedMetroRegion, setSelectedMetroRegion] = useState('전국');
  const [selectedBasicRegions, setSelectedBasicRegions] = useState<string[]>([]);
  const [selectedCategory, setSelectedCategory] = useState('전체');
  const [viewMode, setViewMode] = useState<'map' | 'table'>('map');
  const [favorites, setFavorites] = useState<string[]>([]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        {/* 메인 대시보드 컨테이너 - 1단, 2단을 하나의 테두리 안에 */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-6 mb-4 sm:mb-8">
          {/* 1단: 검색 및 필터링 + 규제환경 지도 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-8">
            {/* 검색 및 필터링 */}
            <div>
              <FilterPanel
                selectedMetroRegion={selectedMetroRegion}
                setSelectedMetroRegion={setSelectedMetroRegion}
                selectedBasicRegions={selectedBasicRegions}
                setSelectedBasicRegions={setSelectedBasicRegions}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                viewMode={viewMode}
                setViewMode={setViewMode}
                favorites={favorites}
                setFavorites={setFavorites}
              />
            </div>
            
            {/* 규제환경 지도 */}
            <div>
              <MapDashboard
                selectedMetroRegion={selectedMetroRegion}
                selectedBasicRegions={selectedBasicRegions}
                selectedCategory={selectedCategory}
                viewMode={viewMode}
                setSelectedMetroRegion={setSelectedMetroRegion}
                setSelectedBasicRegions={setSelectedBasicRegions}
              />
            </div>
          </div>

          {/* 2단: 평가항목별 상세분석 - 좌우 스와이프 가능 */}
          <div className="border-t border-gray-200 pt-4 sm:pt-6">
            <DetailedAnalysis
              selectedMetroRegion={selectedMetroRegion}
              selectedBasicRegions={selectedBasicRegions}
              selectedCategory={selectedCategory}
            />
          </div>
        </div>

        {/* 지역 비교 분석 */}
        <div className="mb-4 sm:mb-8">
          <RegionComparison />
        </div>
      </div>
    </div>
  );
}
